import React from 'react';

import PendingEditLabel from '../../PendingEditLabel';
import { TrailNameColumnValue } from '../types';
import * as styles from './styles/styles.module.scss';

type TrailNameColumnProps = {
  value: TrailNameColumnValue;
};

const TrailNameColumn = ({ value: { editUrl, name, hasPendingEdit } }: TrailNameColumnProps): JSX.Element => (
  <div className={styles.trailName}>
    <a href={editUrl} title={name} target="_blank" rel="noopener noreferrer">
      {name}
    </a>
    {hasPendingEdit && <PendingEditLabel />}
  </div>
);

export default TrailNameColumn;
